import React from 'react';

import Select from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';

import {
  ValueContainerWithOverflow,
  ValueContainerWithOverflowStyles,
} from '@qality/common-components/src/select/select-components/ValueContainerWithOverflow';
import {
  FEATURE_FLAG,
  UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE,
} from '@qality/common-config';
import { StatusSelectOption, StatusUtils } from '@qality/common-utils';

import { useTestCaseFilterContext } from '../../TestCaseFilter';
import { useTestCasesInCycleList } from '../TestCaseInCycleListProvider';
import { ContainerStyled } from './TestCaseInCycleStatusFilter.styled';
import {
  dedupeStatusOptions,
  filterOutAllStatuses,
  handleAllStatusesOption,
} from './TestCaseInCycleStatusFilter.util';

export type StatusOptions = Array<StatusSelectOption>;

export const ALL_STATUSES: StatusSelectOption = {
  label: 'All statuses',
  value: null,
};

export function TestCaseInCycleStatusFilter(): JSX.Element {
  const { statusFilter, setStatusFilter } = useTestCaseFilterContext();

  const { testCycle } = useTestCasesInCycleList();

  const handleChange = (selectedStatusOptions: StatusOptions) => {
    const newStatusFilter = selectedStatusOptions.filter(filterOutAllStatuses);

    setStatusFilter(newStatusFilter);
  };

  const options = StatusUtils.groupStatusesByCategory(
    testCycle.testCases
      .map((testCase) => testCase.statusDetail)
      .reduce(dedupeStatusOptions, [])
  );

  return (
    <ContainerStyled>
      <Tooltip
        content={
          !FEATURE_FLAG.isPremium && UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE
        }
      >
        <Select
          isDisabled={!FEATURE_FLAG.isPremium}
          value={handleAllStatusesOption(statusFilter)}
          options={options}
          onChange={handleChange}
          isMulti
          spacing='compact'
          styles={{
            multiValue: (base) => ({
              ...base,
              ...ValueContainerWithOverflowStyles,
            }),
          }}
          components={{
            ValueContainer: ValueContainerWithOverflow,
          }}
        />
      </Tooltip>
    </ContainerStyled>
  );
}
